module.exports = __webpack_public_path__ + "static/media/play-background-2.26ba3af7.jpg";